import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Layers } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    setIsOpen(false);
    
    if (location.pathname !== '/') {
      // Navigate to home first, then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on home, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const scrollToTop = () => {
    setIsOpen(false);
    
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-lg">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 transition-transform hover:scale-105">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Layers className="h-5 w-5" />
            </div>
            <span className="text-xl font-bold text-foreground">MultiChoice</span>
          </Link>

          <div className="hidden items-center gap-6 md:flex">
            <button
              onClick={scrollToTop}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              Dashboard
            </button>
            <button
              onClick={() => scrollToSection('categories')}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              Categories
            </button>
            <button
              onClick={() => scrollToSection('all-tools')}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              All Tools
            </button>
          </div>

          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>

        {isOpen && (
          <div className="animate-fade-in border-t border-border py-4 md:hidden">
            <div className="flex flex-col gap-4">
              <button
                onClick={scrollToTop}
                className="text-left text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
              >
                Dashboard
              </button>
              <button
                onClick={() => scrollToSection('categories')}
                className="text-left text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
              >
                Categories
              </button>
              <button
                onClick={() => scrollToSection('all-tools')}
                className="text-left text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
              >
                All Tools
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
